import React from 'react';

import { Visualiser } from '../Visualiser';

import { PersonalisationHeader } from '../PersonalisationHeader';
import { PersonalisationStep } from '../PersonalisationStep';
import { PersonalisationFooter } from '../PersonalisationFooter';
import { PersonalisationLoader } from '../PersonalisationLoader';
import { useViewModel } from './useViewModel';

import styles from './personalisation-modal.module.css';

/**
 * PersonalisationModal handles the product personalisation flow, including step navigation.
 * Only the current step is rendered at a time.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onClose - Callback for closing the modal
 * @returns {import('react').JSX.Element}
 */
export function PersonalisationModal({ isOpen, onClose }) {
  const {
    dialogModalRef,
    contentRef,
    contentClassName,
    isSubviewOpen,
    totalSteps,
    currentStep,
    handleClose,
    handleNext,
    handlePrev,
    handleBack,
    handleReset,
    headerTitle,
    headerResetText,
    headerStyle,
    isResetting,
    isAddingToCart,
    isRetrying
  } = useViewModel({ isOpen, onClose });

  return (
    <dialog ref={dialogModalRef} closedby="any" className={styles['personalisation__modal']}>
      <PersonalisationLoader isVisible={isAddingToCart} isRetrying={isRetrying} />
      <PersonalisationHeader
        title={headerTitle}
        resetText={headerResetText}
        onClose={handleClose}
        totalSteps={totalSteps}
        currentStep={currentStep}
        onReset={handleReset}
        onBack={handleBack}
        isResetting={isResetting}
        headerStyle={headerStyle}
      />
      {/*
       * A step's sub-view (the stone picker) takes the screen below the header, so the visualiser
       * and the footer are hidden while it is open - hidden, not unmounted, so their state (the
       * visualiser's slides, the UV insert portal target, an open summary) survives it.
       */}
      {/* Per-row errors are now displayed in the Summary modal for shared journeys. */}
      <div className={styles['personalisation__modal-region']} hidden={isSubviewOpen}>
        <Visualiser width={800} />
      </div>
      <div ref={contentRef} className={contentClassName}>
        <PersonalisationStep />
      </div>
      <div className={styles['personalisation__modal-region']} hidden={isSubviewOpen}>
        <PersonalisationFooter
          onClose={handleClose}
          totalSteps={totalSteps}
          currentStep={currentStep}
          onNext={handleNext}
          onPrev={handlePrev}
          headerStyle={headerStyle}
        />
      </div>
    </dialog>
  );
}
